/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingSeverityRequest {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingSeverityRequest.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingSeverityRequest>): AwsSecurityHubFindingSeverityRequest {
        let obj = Object.assign(new AwsSecurityHubFindingSeverityRequest(), model);
        AwsSecurityHubFindingSeverityRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingSeverityRequest>): AwsSecurityHubFindingSeverityRequest {
        if (!model) return null;
        return AwsSecurityHubFindingSeverityRequest.newInstance(<AwsSecurityHubFindingSeverityRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingSeverityRequest) {
        if (!obj) return;

        models.AwsSecurityHubFindingSeverityRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingSeverityRequest): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingSeverityRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Which tenant Id to fetch severities for
     */
    tenant_id: string;

}
